import React from "react";

import Layout from "./Layout/Layout";

class App extends React.Component {
  render() {
    return (
      <div>
        <Layout />
      </div>
    );
  }
}

export default App;
